import React from 'react'
import { ApplicationVulnerabilityTagsLoader } from '../application-vulnerability-tags'
import { BaseAssessRulesLoader } from '../assess-rules/base-assess-rules-loader'
import { BaseAssessRule } from '../assess-rules'
import { ApplicationServerTagsLoader } from '../application-server-tags'
import { CompliancePoliciesLoader } from '../compliance-policies'
import { CompliancePolicy, DefaultCompliancePolicy } from '../policy'

export interface ChildProps {
  readonly loading: boolean
  readonly assessRules: BaseAssessRule[]
  readonly applicationVulnerabilityTags: string[]
  readonly applicationServerTags: string[]
  readonly compliancePolicies: DefaultCompliancePolicy[]
}

interface Props {
  readonly organizationID: string
  readonly applicationID: string
  readonly children: (props: ChildProps) => React.ReactNode
}

export function AttestationReportLoader({
  organizationID,
  applicationID,
  children
}: Props) {
  return (
    <BaseAssessRulesLoader organizationID={organizationID}>
      {({ baseAssessRules: assessRules }) => {
        return (
          <ApplicationVulnerabilityTagsLoader
            organizationID={organizationID}
            applicationID={applicationID}
          >
            {({ applicationVulnerabilityTags }) => {
              return (
                <ApplicationServerTagsLoader
                  organizationID={organizationID}
                  applicationID={applicationID}
                >
                  {({ applicationServerTags }) => {
                    return (
                      <CompliancePoliciesLoader organizationID={organizationID}>
                        {({ policies, loading }) => {
                          const compliancePolicies =
                            filterDeFaultCompliancePolicies(policies)

                          return children({
                            assessRules,
                            applicationVulnerabilityTags,
                            applicationServerTags,
                            compliancePolicies,
                            loading
                          })
                        }}
                      </CompliancePoliciesLoader>
                    )
                  }}
                </ApplicationServerTagsLoader>
              )
            }}
          </ApplicationVulnerabilityTagsLoader>
        )
      }}
    </BaseAssessRulesLoader>
  )
}

const filterDeFaultCompliancePolicies = (
  policies: CompliancePolicy[]
): DefaultCompliancePolicy[] => {
  const defaultPolicies: DefaultCompliancePolicy[] = []

  policies.forEach((policy) => {
    if (!!policy.key) {
      defaultPolicies.push({
        ...policy,
        key: policy.key
      })
    }
  })

  return defaultPolicies
}
